module.exports = __webpack_public_path__ + "img/activeRight.15db81fd.svg";